import React, { useEffect } from 'react';
import { DataManager } from '../../../core/data-manager';
import moment from 'moment';


export default function IC_supplier_order_rows({ data, entity = null, setDataKeyValue }) {

    useEffect(() => {
        console.warn(data);
        if(data?.idVatCondition === ""){
            getIVA();
        }

        if (data.idItemModel && data.idItemModel !== '' && data.idItemModel !== null) {
            localStorage.removeItem('idItemModelSupplierOrder');
            localStorage.setItem('idItemModelSupplierOrder', data.idItemModel.id);

            if (data.idItemModel.measureUnit && data.measureUnit !== data.idItemModel.measureUnit) {
                setDataKeyValue('measureUnit', data.idItemModel.measureUnit)
            }
            /* if (data.idVatCondition === "" && data.idVatCondition !== data.idItemModel.vat) {
                setDataKeyValue('idVatCondition', data.idItemModel.vat)
            } */
            var a = data.quantity / data.idItemModel.quantityPackages;
            var b = data.quantity * data.idItemModel.grossWeight;
            a = Math.ceil(a);
            if (a && parseInt(data.packages) !== a) {
                setDataKeyValue('packages', a);
            }
            if (b && parseInt(data.grossWeight) !== b) {
                setDataKeyValue('grossWeight', b);
            }
        }

        if (data.idItemModelSupplier) {
            console.log(data.price, data.idItemModelSupplier.price)
            if (parseFloat(data.price) !== parseFloat(data.idItemModelSupplier.price)) {
                setDataKeyValue('price', parseFloat(data.idItemModelSupplier.price))
            }
            if (data.leadtime === "" && data.leadtime !== data.idItemModelSupplier.leadtime) {
                setDataKeyValue('leadtime', data.idItemModelSupplier.leadtime)
            }
        }

        var order = document.querySelector('#supplier_order_field_orderDate input');
        if (order && order.value) {
                if (parseInt(data.leadtime) === 0) {
                    if (data.expectedDate !== order.value) {
                        setDataKeyValue('expectedDate', order.value)
                    }

                } else if (parseInt(data.leadtime) !== 0) {
                    const a = parseInt(data.leadtime)
                    var date1 = moment(order.value, 'YYYY-MM-DD').add(a, 'day');
                    if (data.expectedDate !== date1.format('YYYY-MM-DD')) {
                        setDataKeyValue('expectedDate', date1.format('YYYY-MM-DD'))
                    }
                }
        }
        if (!data.idItemModel) {
            if (document.querySelector('#supplier_order_field_discount1 input')) {
                var d1 = parseFloat(document.querySelector('#supplier_order_field_discount1 input').value);
                if (d1 !== 0 && parseFloat(data.discount1) !== d1) {
                    setDataKeyValue('discount1', d1)
                }
            }
        }
        if (!data.idItemModel) {
            if (document.querySelector('#supplier_order_field_discount2 input')) {
                var d1 = parseFloat(document.querySelector('#supplier_order_field_discount2 input').value);
                if (d1 !== 0 && parseFloat(data.discount1) !== d1) {
                    setDataKeyValue('discount2', d1)
                }
            }
        }
        if (!data.idItemModel) {
            if (document.querySelector('#supplier_order_field_discount3 input')) {
                var d1 = parseFloat(document.querySelector('#supplier_order_field_discount3 input').value);
                if (d1 !== 0 && parseFloat(data.discount1) !== d1) {
                    setDataKeyValue('discount3', d1)
                }
            }
        }
        if (data.price !== "" && data.quantity !== "") {
            var a = (parseFloat(data.price) * parseFloat(data.quantity))
            if (data.discount1) {
                a = a - (a * parseFloat(data.discount1)) / 100
            }
            if (data.discount2) {
                a = a - (a * parseFloat(data.discount2)) / 100
            }
            if (data.discount3) {
                a = a - (a * parseFloat(data.discount3)) / 100
            }
            if (parseFloat(data.totalRow ? data.totalRow : 0).toFixed(2) !== a.toFixed(2)) {
                setDataKeyValue('totalRow', a.toFixed(2))
            }
        }
        if (data.price !== "" && data.idVatCondition) {
            var a = parseFloat(data.quantity) * parseFloat(data.price) * (parseFloat(data.idVatCondition.percentage) / 100)
            if (data.totalIva !== a.toFixed(2)) {
                setDataKeyValue('totalIva', a.toFixed(2));
            }
        }
        if (data.totalIva !== "" && data.totalRow !== "") {
            var a = parseFloat(data.totalRow) + parseFloat(data.totalIva)
            if (data.total !== a.toFixed(2)) {
                setDataKeyValue('total', a.toFixed(2));
            }
        }

    }, [data]);


    useEffect(() => {
        if (data.idItemModel && data.idItemModel !== '' && data.idItemModel !== null) {
            if (data.name !== data.idItemModel.name) {
                setDataKeyValue('name', data.idItemModel.name)
            }
        }
    }, [data.idItemModel])


    async function getIVA() {
        var elIdIva = document.querySelector('#supplier_order_field_idVatCondition *[data-id]');
        console.log(elIdIva)
        if (elIdIva) {
            var idIva = elIdIva.getAttribute('data-id');
            var r = await DataManager.getItem('vat_condition', parseInt(idIva));
            if (r.success === 1) {
                var iva = r.body[0]
                if (data.idVatCondition === "" || data.idVatCondition === null) {
                    setDataKeyValue('idVatCondition', iva)
                }
            }
        }
    }




    return (
        <>
        </>
    )
};